import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { Else, If, Then } from "react-if";
import { dateFormat } from "../utils/functions";
import React, { useEffect } from "react";

import MainContainer from "../components/containers/MainContainer";
import TopBar from "../components/containers/TopBar";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import FetchLogin from "../components/Fetch/FetchLogin";
import { useState } from "react";

const useStyles = makeStyles({
  card: {
    marginTop: 32,

    marginBottom: 0,
    border: "0.5px solid #C4C4C4",

    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    borderRadius: 21,
  },
});

const cardDesign = (bookingDetail, hist, classes) =>
  bookingDetail.map((b, bookingDetailCtr) => (
    <Card
      className={classes.card}
      key={bookingDetailCtr}
      style={{
        backgroundColor: b.win ? "green" : "#fff",
        color: b.win ? "#fff" : "#222",
      }}
    >
      <CardContent>
        <Grid container>
          <Grid item xs={6}>
            Booking #<br />
            <b>{b.book_no}</b>
            <br />
            {b.game.toUpperCase()}
          </Grid>

          <Grid item xs={6}>
            <b>Draw Dates: </b>
            <br />
            {dateFormat("d F Y", b.date)}
            <br />
            <b>Created: </b>
            <br />
            {dateFormat("d F Y, h:i a", b.created_at)}
            <br />
            <Button
              size="small"
              onClick={() => {
                hist.push("/check/" + b.book_no.toLowerCase());
              }}
            >
              See your Bet
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  ));

const Booking = () => {
  const hist = useHistory();
  const classes = useStyles();
  const token = useSelector((state) => state.login.token);

  const [v, setV] = useState({
    bookings: [],
  });

  const setV2 = (v2) => {
    setV((prev) => ({ ...prev, ...v2 }));
  };

  // const reqBooking = Fetch2("booking", {
  // 	method: "post",
  // 	data: {
  // 		token: token,
  // 	},
  // 	callback: (cb) => {
  // 		if (cb.response.status === "success") {
  // 			v.bookings = cb.response.data;
  // 		}
  // 	},
  // });

  const reqBookingList = FetchLogin("booking-list", {
    data: {
      token: token,
    },
    callback: (cb) => {
      if (cb.response.success) {
        setV2({ bookings: cb.response.data.bookings });
      }
    },
  });

  useEffect(() => {
    reqBookingList.handleTrigger();
    // eslint-disable-next-line
  }, []);

  return (
    <MainContainer
      render={
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              height: 50,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TopBar leftSide="-1" title={"Booking List"} />
          </Grid>
        </Grid>
      }
    >
      <If condition={!reqBookingList.loading}>
        <Then>
          {v.bookings.today?.length > 0 && (
            <>
              <h3>Today's Booking</h3>
              {cardDesign(v.bookings.today, hist, classes)}
            </>
          )}

          {v.bookings.upcoming?.length > 0 && (
            <>
              <h3>Upcoming Booking</h3>
              {cardDesign(v.bookings.upcoming, hist, classes)}
            </>
          )}

          {v.bookings.prev?.length > 0 && (
            <>
              <h3>Previous Booking</h3>
              {cardDesign(v.bookings.prev, hist, classes)}
            </>
          )}
        </Then>
        <Else>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80vh",
              flexDirection: "column",
              fontSize: 24,
            }}
          >
            <CircularProgress />
            <br />
            <div>Loading...</div>
          </div>
        </Else>
      </If>
    </MainContainer>
  );
};

export default Booking;
